/*
 * @Author: your name
 * @Date: 2020-05-30 15:57:57
 * @LastEditTime: 2021-01-20 15:53:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-workspace/packages/x-project-app/src/store/auth.store.js
 */
export const SET_CURRENT_ORG = 'SET_CURRENT_ORG'
export const CLEAR_TENANT_STORE = 'CLEAR_TENANT_STORE'
export const SET_CURRENT_DEPARTMENT = 'SET_CURRENT_DEPARTMENT'
export const SET_TODO_NUMBER = 'SET_TODO_NUMBER'
export const SET_DAPTENAT_VERSION = 'SET_DAPTENAT_VERSION'
export const SET_TEMP_TENANT = 'SET_TEMP_TENANT'
export const SET_PLATFORM_TYPE = 'SET_PLATFORM_TYPE'

const tenantStore = {
  namespaced: true,
  state: {
    currentOrg: {},
    department: {},
    todoNumber: 0,
    xdaptenantversion: '',
    tempTenant: {},
    xdapplatform: ''
  },
  mutations: {
    [SET_CURRENT_ORG](state, org) {
      state.currentOrg = org
    },
    [CLEAR_TENANT_STORE](state) {
      state.currentOrg = {}
      state.department = {}
      state.todoNumber = 0
    },
    [SET_CURRENT_DEPARTMENT](state, department) {
      state.department = department || {}
    },
    [SET_TODO_NUMBER](state, number) {
      state.todoNumber = number
    },
    [SET_DAPTENAT_VERSION](state, id) {
      state.xdaptenantversion = id || ''
    },
    [SET_TEMP_TENANT](state, tenant) {
      state.tempTenant = tenant
    },
    [SET_PLATFORM_TYPE](state, type) {
      state.xdapplatform = type || ''
    }
  },
  actions: {},
  getters: {}
}

export default tenantStore
